module.exports = __webpack_public_path__ + "img/slider-21.0b6a1183.jpg";